"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDatabaseClusterDb = void 0;
const getDatabaseClusterDb = ({ httpClient, }) => ({ database_cluster_id, db_name, }) => {
    const path = '/databases';
    const url = `${path}/${database_cluster_id}/dbs/${db_name}`;
    return httpClient.get(url);
};
exports.getDatabaseClusterDb = getDatabaseClusterDb;
//# sourceMappingURL=get-database-cluster-db.js.map